module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-2-d5df827ecfbcc69b09b5c13ca1f2c4eb.jpg";